import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {

  state: {

    userObject: undefined,
    userToken: undefined,
    acceptedTerm: false,
    userPermissions: [],//['atendimento', 'medico', 'administrador'],
    userRule: []
  },

  mutations: {

    setUser (state, payload) {

      state.userObject = payload;
      state.userToken = payload.token;
      if(payload.roles){
        for (const key in payload.roles) {
          if(payload.roles[key].name) { state.userRule.push(payload.roles[key].name) }
          if(payload.roles[key].permissions){
            for (const key2 in payload.roles[key].permissions) {
              if(payload.roles[key].permissions[key2].name) { state.userPermissions.push(payload.roles[key].permissions[key2].name) }
            }
          }
        }
      }
    },

    async updateUser (state, payload) {
      state.userObject.name  = payload.name;
      state.userObject.status  = payload.status;
      state.userObject.email = payload.email;
      state.userObject.phone = payload.phone;
      state.userObject.document = payload.document;
    },

    clearUser (state) {

      state.userToken = null;
      state.userObject = undefined
      state.acceptedTerm = false
      state.userPermissions = []
      state.userRule = []
    },

    setAcceptedTerm (state, payload) {
      state.acceptedTerm = payload;
    },
  },
  actions: {

    async updateUser ({rootState}, payload) {
      let headerConfig ={
        headers: {
          Authorization: 'bearer ${rootState.User.userToken}'
        }
      };
      return await this.$http.put(`api/administrators/roles/${payload.id}`, payload, headerConfig)
          .then(response =>{
            return response;
          })
          .catch(error => {
            return error;
          })
    },

    signUserOut ({ commit }) {

      commit("clearUser");
    },

    async signUserIn ({ commit, dispatch }, payload) {

      commit("clearAlertError");
      commit("setLoader", true);
      await this.$http.post("/api/authentication/login", { email: payload.email, password: payload.password })
        .then( async response => {
          if (response.data && response.data.token) {
            commit("setLoader", false);
            await dispatch('verifyInformationUser', response.data.token)
          }
          else {
            let message = "Email ou senha incorretos";
            commit("setLoader", false);
            commit("setAlertError", { alert: true, message: message });
          }
        })
        .catch( response => {
          let message = "Email ou senha incorretos";
          commit("setLoader", false);
          commit("setAlertError", { alert: true, message: message });
        });
    },

    async verifyInformationUser ({ commit }, payload) {

      let headerConfig = {
        headers: {
          Authorization: `bearer ${payload.token}`
        }
      }
      await this.$http.get("/api/employee", headerConfig)
        .then( response => {
          commit("setUser", { ...response.data.user, type: 'employee', token: payload.token });
          commit("setLoader", false);
        })
        .catch( async response => {
          await this.$http.get("/api/administrator", headerConfig)
            .then( response => {
              commit("setUser", { ...response.data.user, type: 'administrator', token: payload.token });
              commit("setLoader", false);
            })
            .catch( response => {
              let message = "Email ou senha incorretos";
              commit("setLoader", false);
            });
      });
    },

    async updateProfile ({ commit, state }, payload) {

      let headerConfig = {
        headers: {
          Authorization: `bearer ${state.userToken}`
        }
      }
      console.log(payload)
      return await this.$http.put(`/api/${state.userObject.type}`, payload, headerConfig)
        .then( response => {
          commit("updateUser", response.data.user);
          return response;
        })
        .catch( error => {
          return error;
        });
    },

    logOut ({ commit }) {

      commit("clearUser");
      commit("setAcceptedTerm", false);
    },

    acceptedTerm ({ commit }, payload) {

      commit('setAcceptedTerm', payload)
    }
  },
  getters: {

    user (state) {

      return state.userObject;
    },

    acceptedTerm (state) {

      return state.acceptedTerm
    },
    userRule (state) {

      return state.userRule
    },
    userPermissions (state) {

      return state.userPermissions
    }
  }
};
